// extracted by mini-css-extract-plugin
module.exports = {"theme":"#335EB3"};